/**
 * Lexical Editor Theme
 * Tailwind CSS 기반 마크다운 스타일링
 */

import { EditorThemeClasses } from 'lexical';

export const editorTheme: EditorThemeClasses = {
  // 단락
  paragraph: 'mb-4 leading-relaxed',

  // 제목
  heading: {
    h1: 'text-5xl font-bold mb-4 mt-8 leading-tight',
    h2: 'text-4xl font-bold mb-3 mt-6 leading-tight',
    h3: 'text-3xl font-semibold mb-2 mt-4 leading-snug',
    h4: 'text-2xl font-semibold mb-2 mt-3',
    h5: 'text-xl font-semibold mb-2 mt-2',
    h6: 'text-lg font-semibold mb-2 mt-2',
  },

  // 텍스트 스타일
  text: {
    bold: 'font-bold',
    italic: 'italic',
    underline: 'underline',
    strikethrough: 'line-through',
    code: 'font-mono bg-gray-200 dark:bg-gray-800 px-2 py-1 rounded text-sm',
  },

  // 리스트
  list: {
    ul: 'list-disc ml-6 mb-4 space-y-2',
    ol: 'list-decimal ml-6 mb-4 space-y-2',
    listitem: 'ml-2',
    nested: {
      listitem: 'list-none',
    },
  },

  // 인용구
  quote: 'border-l-4 border-blue-500 dark:border-blue-400 pl-4 italic my-4 text-gray-700 dark:text-gray-300',

  // 코드 블록
  code: 'bg-gray-900 text-gray-100 p-4 rounded-lg overflow-x-auto mb-4 font-mono text-sm',

  // 링크
  link: 'text-blue-500 hover:text-blue-700 dark:text-blue-400 dark:hover:text-blue-300 underline cursor-pointer',
};
